import { Observable } from 'rxjs';

export interface WinCCbserverModel {
    winCCObservable: Observable<GroupedWinCCMessages>
};

export enum WinCCArea {
    INTB = "IN-TB",
    TBCF = "TB-CF",
};

export interface WinCCMessage {
    area: WinCCArea,
    description: string,
    localtime: number,
    msgNr: number,
    status: number,
};

export interface GroupedWinCCMessages {
    [x: string]: WinCCMessage
}